<template>
  <div class="table-container pull-auto">
      <!--列表展示-->
      <avue-crud :data="list" :option="tableOption" :page="page" @size-change="sizeChange" @current-change="currentChange" @row-click="showRow">
          <template slot="menuLeft">
            <el-button size="mini" class="filter-item" @click="handleCreate" type="primary" icon="el-icon-plus" v-if="roleManager_btn_add">添加
            </el-button>
            <el-button size="mini" class="filter-item" type="primary" v-if="roleManager_btn_edit" icon="el-icon-edit-outline" @click="handleUpdate1" :disabled="totalState">编辑
            </el-button>
            <el-button :disabled="totalState" size="mini" class="filter-item" @click="handleDelete" type="primary" icon="el-icon-circle-close-outline" v-if="roleManager_btn_del">删除
            </el-button>
            <el-button :disabled="totalState" size="mini" class="filter-item" @click="handlePermission" type="primary"  icon="el-icon-setting" >权限
            </el-button>
            <el-button :disabled="totalState" size="mini" class="filter-item" @click="handleDealing" type="primary" icon="el-icon-setting" v-if="roleManager_btn_perm">分配用户
            </el-button>
          </template>
          <template slot-scope="scope" slot="id">
            <el-radio class="radio" v-model="radio_id"  :label="scope.row.id"></el-radio>
          </template>
      </avue-crud>

      <!--编辑角色-->
       <edit ref="child2" @refresh="refresh"></edit>
      <!--设置权限-->
      <roles ref="child1" @refresh="refresh"></roles>
      <!--设置用户-->
      <setUser ref="child" @refresh="refresh"></setUser>
  </div>
</template>
<script>
  import {fetchList,delObj} from '@/api/admin/role'
  import {mapGetters} from 'vuex'
  import waves from '@/directive/waves/index.js' // 水波纹指令
  import { objKeySort } from '@/util/ajaxsign'
  import edit from './edit.vue'
  import roles from './roles.vue'
  import setUser from './setUser.vue'

  export default {
    name: 'table_role',
    components: {edit,roles,setUser},
    directives: {
      waves
    },
    data() {
      return {
        radio_id :'',
        permissions : [],
        totalState:true,
        roleName : '',
        list: [],
        listLoading: true,
        listQuery: {
          current: 1,
          size: 20
        },
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableOption : {
            addBtn : false,
            refreshBtn : false,
            columnBtn : false,
            editBtn : false,
            delBtn : false,
            menu : false,
            page:true,
            border : true,
            align:'center',
            menuAlign:'center',
            height : window.innerHeight - 240,
            index:false,
            column:[
            {
                label:'',
                prop:'id',
                width:40,
                solt:true
            },
            {
                label:'角色名称',
                prop:'roleName'
            },{
                label:'角色标识',
                prop:'roleName'
            },{
                label:'角色描述',
                prop:'roleDesc'
            },{
              label:'创建时间',
              prop:'createTime',
              type: 'date',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
            }]
        },
      }
    },
    created() {
      this.getList()
      this.permissions = JSON.parse(window.sessionStorage.getItem("userInfo")).permissions;
      for(var i=0;i<this.permissions.length;i++){
        if(this.permissions[i] == 'sys_role_add'){
          this.roleManager_btn_add = this.permissions[i]
        }
        if(this.permissions[i] == 'sys_role_edit'){
          this.roleManager_btn_edit = this.permissions[i]
        }
        if(this.permissions[i] == 'sys_role_del'){
          this.roleManager_btn_del = this.permissions[i]
        }
        if(this.permissions[i] == 'sys_role_perm'){
          this.roleManager_btn_perm = this.permissions[i]
        }

      }
    },
    computed: {},
    methods: {
      //刷新列表操作
      refresh(data){
        this.totalState = true;
        this.getList()
      },
      //新增子页面
      handleCreate(){
        this.$refs.child2.dialog('create');
      },

       // 编辑
      handleUpdate1(row) {
        this.$refs.child2.dialog('update');
        this.$refs.child2.getobj(this.radio_id);  //修改数据赋值
      },

      // 权限弹框
      handlePermission() {
        this.$refs.child1.dialog(this.radio_id,this.roleName);
      },

       // 分配
      handleDealing(){
       this.$refs.child.dialog(this.radio_id);
      },
      // 删除
      handleDelete(row) {
        this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delObj(objKeySort({id:this.radio_id})).then(response => {
            if (response.status === 200) {
              this.dialogFormVisible = false
              this.getList()
              this.$message({
                title: '成功',
                message: '删除成功',
                type: 'success',
                duration: 2000
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },

      getList() {
        this.listLoading = true
        console.log(objKeySort(this.listQuery))
        fetchList(objKeySort(this.listQuery)).then(response => {
          for(var i=0;i<response.data.data.rows.length;i++){
            response.data.data.rows[i].id = response.data.data.rows[i].roleId;
            delete response.data.data.rows[i].roleId;
          }
          this.list = response.data.data.rows
          this.page.total = response.data.data.total
          this.listLoading = false
        })
      },
      //条数
      sizeChange(val) {
        this.listQuery.size = val;
        this.getList();
      },
      //页码
      currentChange(val) {
        this.listQuery.current = val;
        this.getList();
      },

      //点击列数据
      showRow(data){
        this.totalState=false;
        this.radio_id = data.id;
        this.roleName = data.roleName;
        this.$emit('data',data.pkg);
      },
    }
  }
</script>
<style lang="scss" scoped>
  .el-table{
    margin-top:22px;
}
.el_s_left{
    float:left
}
.el_btn{
    clear:both;
}

.filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }

  .sh_tip{
      vertical-align:top;
      display:inline-block
  }
  .lf_item span:first-child{
      display:inline-block;
      width:100px;
      vertical-align:top;
  }
  .el-form-items{
    float: left;
    width: 48%!important;
  }
  .el-form-itemss{
    width: 300px!important;
    height: 40px!important;
    background-attachment: #fff!important;
  }
  .el-form-itemss .el-input{
    outline: none!important;
  }
  .el-f-item{
    width: 100%!important;
  }
  .el-dialog__header{
    margin-bottom: 25px;
  }
  .el-tag{
    border: 0!important;
    color: #666!important;
    background-color: transparent;
    font-size:14px;
  }
  .dialog-footer{
    margin-left: 0!important;
  }
  .p1{
    width:100% !important;
  }
  .el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }

</style>
